import React, {
  createContext,
  useReducer,
  useEffect,
  useCallback,
} from "react";
import reducers from "./Reducers.js";

const initialState = {
  publicPhenomenaGroups: [],
};

export const DataContext = createContext(initialState);

export const DataProvider = ({ children, node }) => {
  const [state, dispatch] = useReducer(reducers, initialState);

  return (
    /* eslint-disable */
    <>
      <DataContext.Provider value={{ state, dispatch }}>
        {children}
      </DataContext.Provider>
    </>
  );
};
